// extracted by mini-css-extract-plugin
export default {"RegistrationsList":"RegistrationsList_RegistrationsList__dEvNA"};